module.exports = __webpack_public_path__ + "img/bg_cod.68ca8692.png";